/** The three "agent is active on this DoBox" states shared by the card strip, the header
 *  chip and the panel run view (DoBox agent-presence proposal, screens 5-8). DONE has no
 *  state here on purpose — resolveAgentPresence returns null once the task is resolved, so
 *  the strip simply disappears rather than rendering a fourth state. */
export enum AgentPresenceState {
  WORKING = 'WORKING',
  NEEDS_YOU = 'NEEDS_YOU',
  REVIEW = 'REVIEW',
}
